import { createContext, useContext, useState, useEffect } from 'react';
import { UserContext } from './UserContext';

export const ModeContext = createContext({});
export const ModeContextProvider = ({ children, props }) => {
  const {
    state: { userRole },
  } = useContext(UserContext);
  const [adminView, setAdminView] = useState(userRole ? userRole !== 'patient' : false);
  useEffect(() => {
    if (userRole) {
      setAdminView(userRole !== 'patient');
    }
  }, [userRole]);
  const toggleAdminView = () => {
    setAdminView(!adminView);
  };
  return (
    <ModeContext.Provider
      value={{
        actions: { toggleAdminView },
        state: {
          adminView,
        },
      }}
      {...props}
    >
      {children}
    </ModeContext.Provider>
  );
};
